import React, {useEffect, useState} from 'react';
import uuidv4 from 'uuid/v4';
import {useSelector} from 'react-redux';
import {user} from '../../../../store/reducers/user';
import moment from 'moment';
import {DialogSeenAndWhenExt} from '../../../../controls/agyle/clinician/dialogSeenAndWhenExt';
import {MedicalNursePlanInput} from '../../../../controls/agyle/clinician/medicalNursePlanInput';

const DEFAULT_VALUES = {
    who: null,
    when: moment(),
    timestamp: null,
    notes: [],
};

const PlansForm = (props) => {
    // Selectors
    const userObject = useSelector(user);

    const [valueSeen, setValueSeen] = useState(props.value || DEFAULT_VALUES);
    const initNote = {id: uuidv4(), text: '', checked: false, checkedBy: null};
    const [initialNote, setInitialNote] = useState(initNote);
    const [medicalNursingNotes, setMedicalNursingNotes] = useState(valueSeen?.notes || []);
    const [addBtnSeen, setAddBtnSeen] = useState(true);

    useEffect(() => {
        props.onChangingValues({
            ...valueSeen,
            notes: medicalNursingNotes,
            timestamp: moment().toISOString(),
        });
    }, [medicalNursingNotes, valueSeen]);

    return (
        <>
            <MedicalNursePlanInput
                setFormIsModified={props.setFormIsModified}
                medicalNursingNotes={medicalNursingNotes}
                setMedicalNursingNotes={setMedicalNursingNotes}
                addBtnSeen={addBtnSeen}
                setAddBtnSeen={setAddBtnSeen}
                seenDefault={valueSeen}
                user={userObject}
                initialNote={initialNote}
                setInitialNote={setInitialNote}
                initNote={initNote}
                seen={valueSeen}
                refresh
            />

            <DialogSeenAndWhenExt
                patient={props.patient}
                nurse={false}
                cliniciansWithNurses
                size="small"
                label={props.label}
                value={valueSeen}
                findUser={userObject?.userName}
                allowedConsultants={props.allowedConsultants}
                onChange={(value) => {
                    setValueSeen(value);
                    props.setFormIsModified(true);
                }}
                admittedDate={props.ambulanceHandover}
                disableDateManipulation={props.disableDateManipulation}
                refresh
            />
        </>
    );
};
export default PlansForm;